export default __webpack_public_path__ + "static/media/grid-page.423eb22f.png";